import type { ImageValue } from '@elfsight/configurator-contracts';

export function getFileData(file?: ImageValue | string) {
  const result = { url: '', name: '' };

  if (file) {
    if (typeof file === 'string') {
      result.url = file;
      result.name = file.substring(file.lastIndexOf('/') + 1);
    }

    if (typeof file === 'object') {
      // @ts-expect-error possibly legacy file uploader includes file_url property, but now ImageValue doesn't support it
      const { file_url: fileUrl = '', url = '', name = '' } = file;
      result.url = fileUrl || url;
      result.name =
        name ||
        (fileUrl || url || '').substring(
          (fileUrl || url || '').lastIndexOf('/') + 1
        );
    }
  }

  return result;
}
